import BaseProfilEcritureMouvement from './BaseProfilEcritureMouvement';

class BaseProfilEcritureDepense extends BaseProfilEcritureMouvement {}

export default BaseProfilEcritureDepense;
